import { useCallback, useEffect, useState } from "react";

interface Props<R> {
  queryFn: () => Promise<R>;
  enabled?: boolean;
}

const useQuery = <R>({ queryFn, enabled = true }: Props<R>) => {
  const [error, setError] = useState<Error | undefined>();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<R | undefined>();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const response = (await queryFn()) as R;
      setData(response);
    } catch (error) {
      setError(error as Error);
    } finally {
      setLoading(false);
    }
  }, [queryFn]);

  useEffect(() => {
    if (enabled) {
      fetchData();
    }
  }, [fetchData, enabled]);

  const refetch = () => {
    fetchData();
  };

  return {
    error,
    data,
    loading,
    refetch,
  };
};

export default useQuery;
